'use strict';

import validator from '../../validator';

/**
 * @function
 * @description Toggle between guest and account checkout
 */
function toggleCheckoutMethod() {
	$('.checkout-toggle-link').on('click', function() {
		$('.checkoutlogin').toggleClass('account');
	});
}

/**
 * @function
 * @description Enable/disable button depending if input has value and mandatory field
 */
function enableDisableSubmitButton(el) {
	var $saveBtn = $(el).closest('form').find('button[type="submit"]');
	var hasError = $saveBtn.closest('form').find('span.error');
	if(hasError.length) {
		return true
	} else {
		return false;
	}
}

function checkoutButtonEnableDisable() {
	//Guest Checkout
	if($('.guest-checkout').length) {
		var form = $('form[id="guest-login"]'),
			emailButton1 = $('.guest-checkout button'),
			emailInput1 = $('.guest-checkout input[type="email"]'),
			setDefaultCheckbox1 = $('input[id$="_termsandconditions"]');

			$(emailInput1).on('blur', function() {
				var validator = form.validate();
				var validFlag = validator.element($(this));
				emailButton1.prop('disabled', $(form).find('.error-placement').length > 0 ? true : false);
			});
	}

	//Account Checkout
	if($('.account-checkout').length) {
		var emailButton2 = $('.account-checkout .login-account button'),
			emailInput2 = $('.account-checkout .login-account input[type="email"]'),
			password = $('.account-checkout .login-account input[type="password"]');
		$(emailInput2, password).on('blur focus', function() {
			var email_regx =  validator.regex.email;
			if (email_regx.test(emailInput2.val())) {
				if(!password.val().length || enableDisableSubmitButton(emailButton2)) {
					emailButton2.prop('disabled', 'disabled');
				} else {
					emailButton2.prop('disabled', false);
				}
			} else {
				emailButton2.prop('disabled', 'disabled');
			}
		});
	}

	//Existing Account Checkout
	if($('.existing-account-login').length) {
		var emailButton3 = $('.existing-account-login button#login'),
			emailButton4 = $('.existing-account-login button#guestcheckout'),
			password3 = $('.existing-account-login input[type="password"]');
		$(password3).on('blur', function() {
			if (!password3.val().length) {
				emailButton3.prop('disabled', 'disabled');
			} else {
				emailButton3.prop('disabled', false);
			}
			enableDisableSubmitButton(emailButton3);
			emailButton4.prop('disabled', false);
		});
	
		if (!password3.val().length) {
			emailButton3.prop('disabled', 'disabled');
		}
	}
}

export default {
	init: function () {
		toggleCheckoutMethod();
		checkoutButtonEnableDisable();
	}
}
